module.exports = __webpack_public_path__ + "img/banner.4142577f.jpg";